// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_package".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { depositBasisValues, servicePaymentPolicyValues } from '@borradh-workspace/labels';
/** Response atom for the "organization_package" table (1:1 with a DB row, on the wire). */
export const organizationPackageAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    categoryId: z.string().nullable(),
    priceCents: z.number(),
    validityDays: z.number().nullable(),
    requiresDeposit: z.boolean(),
    paymentPolicy: z.enum(servicePaymentPolicyValues).nullable(),
    depositBasis: z.enum(depositBasisValues).nullable(),
    depositAmountCents: z.number().nullable(),
    depositPercent: z.number().nullable(),
    sortOrder: z.number(),
    isActive: z.boolean(),
    sellOnline: z.boolean(),
    deletedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationPackage.js.map